import React from 'react';
import DetailsModelTableWrapper from '../details-model-table-wrapper';
import DetailsModelTableRow from '../details-model-table-row';
import rowColors from './utils/details-model-colors';

const { rowColor1, rowColor2, rowColor3 } = rowColors;

const EscalationDetailsModalTable = ({ type, tableData, multiplyOn, formData, hideDetails }) => {
  const { markupDetails, contingencyDetails, escalationDetails } = tableData;

  // Markup
  const { markupCost, totalAfterMarkup, totalMarkupPercentage } = markupDetails;

  // Contingency
  const { contingencyCost, totalAfterContingency, totalContingencyPercentage } = contingencyDetails;

  // Escalation
  const { escalationPercentages, escalationCost, totalAfterEscalation, totalEscalationPercentage } =
    escalationDetails;

  const selectedKeys = Object.entries(multiplyOn)
    .filter(([key, value]) => formData[key] && value === true)
    .map(([key]) => key.charAt(0).toUpperCase() + key.slice(1).toLowerCase());

  return (
    <DetailsModelTableWrapper
      type={type}
      subtotal={totalAfterEscalation[5].toFixed(2)}
      TotalCost={escalationCost[5].toFixed(2)}
      tableData={tableData}
      hideDetails={hideDetails}
    >
      {[
        {
          title: 'Markup Cost',
          values: markupCost.map((item) => `$${item.toFixed(2)}`),
        },
        {
          title: 'Markup Percentage',
          values: totalMarkupPercentage.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Cost With Markup',
          values: totalAfterMarkup.map((item) => `$${item.toFixed(2)}`),
          bgColor: rowColor3,
        },
        {
          title: `Contingency Cost`,
          values: contingencyCost.map((item) => `$${item.toFixed(2)}`),
        },
        {
          title: 'Contingency Percentage',
          values: totalContingencyPercentage.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Cost With Contingency',
          values: totalAfterContingency.map((item) => `$${item.toFixed(2)}`),
          bgColor: rowColor3,
        },
        {
          title: `Escalation Cost  ${
            selectedKeys.length > 0 ? `(Including ${selectedKeys.join(', ')} Cost)` : ''
          }`,
          values: escalationCost.map((item) => `$${item.toFixed(2)}`),
        },
        {
          title: 'Escalation Percentage',
          values: escalationPercentages.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Total Cost',
          values: totalAfterEscalation.map((item) => `$${item.toFixed(2)}`),
          boldValues: true,
        },
        {
          title: 'Total Percentage',
          values: totalEscalationPercentage.map((item) => `${item.toFixed(2)}%`),
          bgColor: rowColor1,
        },
        {
          title: 'Percentage',
          values: escalationPercentages.map((item) => `${item.toFixed(2)}%`),
        },
        {
          title: 'Total Escalation Cost',
          values: escalationCost.map((item) => `$${item.toFixed(2)}`),
          bgColor: rowColor3,
        },
      ].map((row, index) => (
        <DetailsModelTableRow
          key={index}
          title={row.title}
          description={row?.description || ''}
          values={row.values}
          bgColor={row?.bgColor || ''}
          boldValues={row?.boldValues || false}
          hideDetails={hideDetails}
        />
      ))}
    </DetailsModelTableWrapper>
  );
};

export default EscalationDetailsModalTable;
